import React from "react";
import { Box } from "@mui/material";

const VideoHeader = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "35rem", md: "45rem" }, // Responsive height
        overflow: "hidden",
        clipPath: {
          xs: `polygon(0 0,100% 0,100% 90%,50% 100%,0 90%)`,
          md: `polygon(0 0,100% 0,100% 85%,50% 100%,0 85%)`,
        },
      }}
    >
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          minWidth: "100%",
          minHeight: "100%",
          transform: "translate(-50%, -50%)",
          objectFit: "cover",
          zIndex: 0,
        }}
      >
        <source src="/assets/video/landing-page-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay gradient */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.15))",
          zIndex: 1,
        }}
      />

      {/* Optional content slot */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          color: "#fff",
          textAlign: "center",
          px: 2,
        }}
      >
        {/* Add future headings, text, or buttons here */}
      </Box>
    </Box>
  );
};

export default VideoHeader;
